import { Alert } from "@/components/Alert";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faCheckCircle,
  faInfoCircle,
  faSpinnerThird,
  faTimesCircle,
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

const OnboardingStatus = (props: IMatConfigurationStatusProperty) => {
  const { heading, description, state } = props;

  const getAlertConfig = (): {
    variant: "success" | "error" | "info" | "warning";
    icon: IconProp;
    iconProps?: Omit<FontAwesomeIconProps, "icon">;
  } => {
    switch (state) {
      case "COMPLETE":
        return {
          variant: "success",
          icon: faCheckCircle,
          iconProps: undefined,
        };
      case "IN_PROGRESS":
        return {
          variant: "info",
          icon: faSpinnerThird,
          iconProps: {
            spin: true,
          },
        };
      case "FAILED":
        return {
          variant: "error",
          icon: faTimesCircle,
          iconProps: undefined,
        };
      case "NOT_STARTED":
      default:
        return {
          variant: "warning",
          icon: faInfoCircle,
          iconProps: undefined,
        };
    }
  };

  return (
    <Alert titleSlot={heading} {...props} {...getAlertConfig()}>
      {description}
    </Alert>
  );
};

export default OnboardingStatus;
